import { IonContent, IonHeader, IonItemDivider, IonPage, IonToolbar, IonButtons, IonButton, IonLabel, IonItem, isPlatform } from "@ionic/react";
import { Colour, FontType, Hindit, HistoryLoaded, HistorySpos, SongsHistory } from "../global";
import { ArrowBackSharp } from "@mui/icons-material";
import  { useContext, useEffect, useRef } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";


function HistoryPage() {
    let { url } = useRouteMatch();
    const [songsHistory,] = useContext(SongsHistory)
    const [clr, ] = useContext(Colour);
    const [font, ] = useContext(FontType);
    const [hindit, ] = useContext(Hindit);
    const [loadAll, setLoadAll] = useContext(HistoryLoaded)
    const contentRef = useRef();
    const [spos, setSpos] = useContext(HistorySpos);
    let locy = 0;
    let location = useLocation();
    let history = useHistory();
    let fon;
    if (!font) fon = "Calibri, sans-serif";
    else fon = "Times New Roman, serif";
    let color2,color3,colori,colorh;
    if(clr === "1") {
     color2 = "#00CBFE";
     color3 = "white"
     colori = ""
     colorh = "primary"
    }
    if(clr === "2") {
     color2 = "#FFE34D";
     color3 = "black"
     colori = "secondary"
     colorh = "warning"
    }
    if(clr === "3") {
     color2 = "#FFA500";
     color3 = "black"
     colori = "secondary"
     colorh = "success"
    }
    if(clr === "4") {
     color2 = "#87CEEB";
     color3 = "black"
     colori = "secondary"
     colorh = "tertiary"
    }
    if(clr === "5") {
     color2 = "#FFE34D";
     color3 = "black"
     colori = "dark"
     colorh = "warning"
    }
    if(clr === "6") {
     color2 = "#87CEEB";
     color3 = "black"
     colori = "dark"
     colorh = "tertiary"
    }

    useEffect(() => {
        if (location.pathname === url && contentRef.current) contentRef.current.scrollToPoint(0,spos);
     }, [location, contentRef.current]);

    return(
        <IonPage>
               
            <IonHeader>
            <IonToolbar color={colorh}>
    <IonButtons slot="start" onClick={() => {
        if(history.length > 1){
          history.goBack()
        }else{
          history.push("/home");
        }
        setLoadAll(false)
        setSpos(0)
    }}>
     <IonButton>
     <ArrowBackSharp style={{ fontSize: 30 }} />
     </IonButton>
    </IonButtons>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "गानों का हिस्ट्री" : "History"}</IonLabel>
   </IonToolbar>
            </IonHeader>
            <IonContent onIonScroll={(e)=>{
        locy = e.detail.scrollTop;
      }} onIonScrollEnd = {()=>{setSpos(locy)}} ref={contentRef} scrollEvents={true} color={colori}>
            <div style={{height:"2px"}}></div>
                {Object.keys(songsHistory).slice((loadAll ? 0 : -2)).reverse().map((date,i)=>{
                     return(
                    <div key={i}>
                     <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
                     <IonLabel style={{ fontFamily: `${fon}` }}>{date.split('-').reverse().join('-')}</IonLabel>
                    </IonItemDivider>
                   
                    {songsHistory[date].slice().reverse().map((song,j)=>{
                        return (
                            <IonItem key={j} button={isPlatform('desktop') ? true : false}        color={colori}
                            onClick={() => {
                              history.push(song.path);
                            }}
                           >
                             <IonLabel style={{ fontFamily: `${fon}` }}>
                                <h2>{hindit ? song.hname : song.name}</h2>
                                <p>{song.time}</p>
                            </IonLabel>
                            </IonItem>
                        )
                    })}
                    </div>
                    )
                })}
            
            {!loadAll && Object.keys(songsHistory).length > 2 ? <div style={{textAlign:"center", margin: "20px"}}>
            <IonButton onClick={()=>{setLoadAll(true)}}>
                {hindit ? "सभी लोड करें" : "Load All"}
            </IonButton>
            </div> : null}
            </IonContent>
        </IonPage>
    );
}

export default HistoryPage;